import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { useTitleRampNames } from '../../shared/useTitleRampNames';
export var TableBodyRowBase = function () {
    var _a = useTitleRampNames('BodyRowContainer', null), containerRampName = _a.rampName, containerRampFallbacks = _a.rampFallbacks;
    return (React.createElement(RampWithNameTransform, { rampName: containerRampName, rampFallbacks: containerRampFallbacks },
        React.createElement(RampWithNameTransform, { rampName: "BodyRowContent" })));
};
